import React from "react";
import { useCustomisation } from "../../context/CustomisationContext";
import { Box } from "@mui/material";
import { resolveAssetUrl } from "../../utils/helpers";

interface LogoProps {
  isLoginPageLogo?: Boolean;
}

const Logo: React.FC<LogoProps> = ({ isLoginPageLogo = true }) => {
  const { customisations } = useCustomisation();

  const {
    LOGIN: { logoSettings: loginLogoSettings },
    GPC: { logoSettings: gpcLogoSettings },
  } = customisations.customisations;
  const logo = !isLoginPageLogo
    ? gpcLogoSettings?.gpcLandscapeLogo
    : (loginLogoSettings?.loginLandscapeLogo ??
      gpcLogoSettings?.gpcLandscapeLogo);
  const logoUrl = resolveAssetUrl(logo);
  const sxStyles = {
    logoContainer: {
      maxWidth: 200,
      height: 50,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "transparent",
    },

    portalLogo: {
      height: 50,
      maxWidth: 200,
      width: "auto",
      objectFit: "contain",
      objectPosition: "center",
      display: "block",
      cursor: "pointer",
    },
  };

  const redirectToHome = () => {
    if (typeof window !== "undefined") {
      window.location.href = "/";
    }
  };

  return (
    <Box sx={sxStyles.logoContainer}>
      {logoUrl ? (
        <Box
          component="img"
          src={logoUrl}
          alt="logo"
          crossOrigin="anonymous"
          sx={sxStyles.portalLogo}
          onClick={redirectToHome}
        />
      ) : null}
    </Box>
  );
};

export default Logo;
